// extracted by mini-css-extract-plugin
export default {"primaryButton":"Button_primaryButton__4av-2"};